// extracted by mini-css-extract-plugin
export default {"container":"HighChartsMap_container__TvnDU"};